import { isCanlan } from './customer-name'

/* Felipe Nunes: Updated Sat, 28 Mar 2026 22:35 PM ( CET ) */
// If it fails (like if the previously set hardcoded token is expired)
// try setting the hardcoded token again (hopefully a new one)
// {
//   "access_token": "v2.local.kbX6dBc4VHB6UwQ6s4JjAKLR3uURz5c7aCOWpDk4vVfC3LM_a9BgjvEl6JSyzp1bqo6gwbORDVBq7yeQnMPt4WSaKuRoU7oZzeSKYkwe0J_rLiKdGlVL2juS5A3FY7nQlSctil87HvOKRwPRJQ2g53E_mHhysr_OsyO2sI8ty2X-JuM9TAKFx7CVuuBUYXrb6k73ZBkzQf5H0p678AeFO8mMNLdxAjlf-pxhRSc8JlOK6OJGtvo20Uxr-2C673UHl32RSGR2J8L3KNgCph0lgZJ-TZFYvgI-ICWTtVQAKn0c6LjA5tpSyRdEypPE7EqHV8CAeQN2uw05-RJDWOl8nfAFBGG-DOjBXA",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-06-29T15:45:20.741209Z",
//   "user": {
//     "id": "TAcc3KT6ikeaqhvL",
//     "email": "michael+planeticeservice@sportninja.com",
//     "account_id": null,
//     "created_at": "2022-08-29T23:14:34+00:00",
//     "updated_at": "2026-03-28T21:34:45+00:00",
//     "validated_at": "2022-08-29T23:14:42+00:00"
//   }
// }
const planetIceToken =
  'v2.local.kbX6dBc4VHB6UwQ6s4JjAKLR3uURz5c7aCOWpDk4vVfC3LM_a9BgjvEl6JSyzp1bqo6gwbORDVBq7yeQnMPt4WSaKuRoU7oZzeSKYkwe0J_rLiKdGlVL2juS5A3FY7nQlSctil87HvOKRwPRJQ2g53E_mHhysr_OsyO2sI8ty2X-JuM9TAKFx7CVuuBUYXrb6k73ZBkzQf5H0p678AeFO8mMNLdxAjlf-pxhRSc8JlOK6OJGtvo20Uxr-2C673UHl32RSGR2J8L3KNgCph0lgZJ-TZFYvgI-ICWTtVQAKn0c6LjA5tpSyRdEypPE7EqHV8CAeQN2uw05-RJDWOl8nfAFBGG-DOjBXA'

// {
//   "access_token": "v2.local.E1XoUBfadNbaJ3DvMFTlQG0PC3lviVEFezCGuSg2lWm3Bfs5JWKh5yxuWLDU5Du1ZRENutIQScu1TkFeEI-nCzPUJOxdlUC0OVclNrJot4JbJWE1i2cLafzo6pfbwr-DJ_qzoPI-9r69bgwhUA1YUBfptzTdF_IeXljkORvxckhmGhneZPpSFH2lyd40D0ycXOb14SzWx9RXsDM2ySffGRjtXsm1P_Y02vxb-ZpEgwP7dcCdOmlZT_iI4fAt7KN_lxw_n3G3lVjniPN1bvoGKkBnCPl8Soc_enb1pwmGhySoDfluaemFo046cD-lQ01_Opi-kN4u6plWhpPkDm2T8mC-Pj2R",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-06-29T15:45:21.030148Z",
//   "user": {
//     "id": "oP37ysYCd57bFlkj",
//     "email": "michael+carhaservice@sportninja.com",
//     "account_id": null,
//     "created_at": "2022-05-27T18:35:59+00:00",
//     "updated_at": "2026-03-28T21:36:19+00:00",
//     "validated_at": "2022-05-27T18:35:59+00:00"
//   }
// }
const carhaToken =
  'v2.local.E1XoUBfadNbaJ3DvMFTlQG0PC3lviVEFezCGuSg2lWm3Bfs5JWKh5yxuWLDU5Du1ZRENutIQScu1TkFeEI-nCzPUJOxdlUC0OVclNrJot4JbJWE1i2cLafzo6pfbwr-DJ_qzoPI-9r69bgwhUA1YUBfptzTdF_IeXljkORvxckhmGhneZPpSFH2lyd40D0ycXOb14SzWx9RXsDM2ySffGRjtXsm1P_Y02vxb-ZpEgwP7dcCdOmlZT_iI4fAt7KN_lxw_n3G3lVjniPN1bvoGKkBnCPl8Soc_enb1pwmGhySoDfluaemFo046cD-lQ01_Opi-kN4u6plWhpPkDm2T8mC-Pj2R'

// {
//   "access_token": "v2.local.iGVkJm_l0CVAozISieUm-st8Tp2kvZRtIdzT0_-Ovfu3WBWVYNVA-ni73bPthVR9Pp-BJnJe7w_zaZKWsu_74bITlwjRMbGkIdhpS_pZfKlQrpkTCYFM0dfRgnRLq_bmYGjQm7Sa06MDUbe5nUBcpeAJk9rdiwRueFRTFPQs5GaCPKcplh9uuA9oyLw2V-d1Ca4-BFupfDR2Re0BqSgQ9_v-h7HIzMgiorh9CiB4J4jycGyRHU1KLaJStF7UmZMOR9k9Wjef0XIinIrGRrsVWgo_jAIl6imtn0h3j3YmY2cJo4N9YebLJWzVjYCGWetoIVs5PLlOK74z-AipMl5KVdzgIn4",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-06-29T15:45:21.365907Z",
//   "user": {
//     "id": "jJkc8qSsffa24rAE",
//     "email": "michael+canlanservice@sportninja.com",
//     "created_at": "2022-05-30T20:39:26+00:00",
//     "updated_at": "2023-05-19T19:59:44+00:00",
//     "validated_at": "2022-05-30T20:39:26+00:00"
//   }
// }
const canlanToken =
  'v2.local.iGVkJm_l0CVAozISieUm-st8Tp2kvZRtIdzT0_-Ovfu3WBWVYNVA-ni73bPthVR9Pp-BJnJe7w_zaZKWsu_74bITlwjRMbGkIdhpS_pZfKlQrpkTCYFM0dfRgnRLq_bmYGjQm7Sa06MDUbe5nUBcpeAJk9rdiwRueFRTFPQs5GaCPKcplh9uuA9oyLw2V-d1Ca4-BFupfDR2Re0BqSgQ9_v-h7HIzMgiorh9CiB4J4jycGyRHU1KLaJStF7UmZMOR9k9Wjef0XIinIrGRrsVWgo_jAIl6imtn0h3j3YmY2cJo4N9YebLJWzVjYCGWetoIVs5PLlOK74z-AipMl5KVdzgIn4'

export const getIframeToken = () => {
  const parentUrl =
    window.location !== window.parent.location
      ? window?.document?.referrer
      : window?.document?.location?.href

  let isPlanetIce = false
  if (parentUrl && parentUrl.includes('pacificadulthockey.com')) {
    isPlanetIce = true
  }
  return isCanlan ? canlanToken : isPlanetIce ? planetIceToken : carhaToken
}
